import React, { useState, useEffect } from 'react'
import { Navigate } from 'react-router-dom'
import { onAuthStateChanged, auth } from '../services'
import { useLoadingStore } from '../store/loadingStore'

/**
 * Wrapper for public routes (login, signup, etc).
 * Redirects authenticated users to /projects so they can't land on auth pages.
 */
function PublicRoute({ children }) {
  const [loading, setLoading] = useState(true)
  const [user, setUser] = useState(null)
  const startLoading = useLoadingStore((state) => state.startLoading)
  const stopLoading = useLoadingStore((state) => state.stopLoading)

  useEffect(() => {
    startLoading()
    // Même garde-fou que ProtectedRoute : le cleanup ne solde le compteur
    // que si l'auth n'a jamais répondu (sinon double stopLoading).
    let pending = true
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      pending = false
      setUser(currentUser)
      setLoading(false)
      stopLoading()
    })

    return () => {
      unsubscribe()
      if (pending) stopLoading()
    }
  }, [startLoading, stopLoading])

  if (loading) {
    return null
  }

  if (user) {
    return <Navigate to="/projects" replace />
  }

  return children
}

export default PublicRoute
